export default {
  pressReleases: []
}
